<!-- <div class="row align-items-end">
  <div class="col">
    @if (headline) {
      <h3 class="mb-5">{{ headline }}</h3>
    } @else {
      <h3 class="mb-5">{{ texts.defaultHeadline[language] }}</h3>
    }
  </div>
</div> -->

@if (!readOnly) {
  <div class="feed-section">
    <div class="form-group mb-0">
      <div class="row">
        @if (user) {
          <div class="col-auto me-n2">
            <sc-avatar size="sm" [user]="user"></sc-avatar>
          </div>
        }
        <div class="col">
          <autosize-textarea [(text)]="input" [placeholder]="mentionItems?.length ? texts.mentionPlaceholder[language] : texts.commentPlaceholder[language]" [mentionable]="mentionItems"></autosize-textarea>
        </div>
        @if (input.length > 0) {
          <div class="col-12 d-flex justify-content-end mt-3">
            <button class="btn btn-primary btn-sm" [disabled]="isSending" (click)="submit()">{{ texts.comment[language] }}</button>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (activities?.length > 0) {
  <div class="list-group feed" [class.condensed]="condensed">
    @for (activity of activities; track activity) {
      @if (isNavigable) {
        <a class="list-group-item list-group-item-action fw-normal" (click)="navigate.emit(activity)">
          <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{'activity':activity, 'context':context}"></ng-template>
        </a>
      } @else {
        <div class="list-group-item fw-normal">
          <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{'activity':activity, 'context':context}"></ng-template>
        </div>
      }
    }
  </div>
}

@if (activities?.length == 0 && !isLoading) {
  <div class="feed-section">
    <p class="mb-0 text-muted">
      {{ texts.empty[language] }}
    </p>
  </div>
}

@if ((hasMoreItems && canLoadMore) || isLoading) {
  <div class="feed-section">
    <div class="row d-flex justify-content-center">
      <div class="col-auto">
        <a class="btn btn-secondary btn-sm" [class.loading]="isLoading" (click)="loadItems()">{{ texts.loadMore[language] }}</a>
      </div>
    </div>
  </div>
}